import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import App from './App.vue';

Vue.use(ElementUI);

let a = {}
Object.defineProperty(a,'name',{value:'123'})

// console.log(a.name)

Object.getOwnPropertyDescriptor({a:false},'a').writable=false



console.log(Object.getOwnPropertyDescriptor({a:true},'a').writable)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
